(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[245],{

/***/ 71962:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/media/news_detail/[newsId]",
      function () {
        return __webpack_require__(51957);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 41520:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ PageLayout; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60357);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(55124);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30552);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2261);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25194);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18700);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(94375);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _stores__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(70959);













var PageLayout = function(param) {
    var children = param.children, _crumb = param.crumb, crumb = _crumb === void 0 ? [] : _crumb, _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? "white" : _backgroundColor, _banner = param.banner, banner = _banner === void 0 ? "/image/about-banner.png" : _banner, newsPath = param.newsPath;
    var ref, ref1;
    var nav = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_stores__WEBPACK_IMPORTED_MODULE_10__/* .IndexContext */ .Z).nav;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), menu = ref2[0], setMenu = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), active = ref3[0], setActive = ref3[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), visible = ref4[0], setVisible = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isSearch = ref5[0], setIsSearch = ref5[1];
    var navTo = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(e, item) {
        if (router.asPath == item.path) {
            return;
        }
        e.stopPropagation();
        // if (item.path === '/audience/register') {
        //   setVisible(true)
        //   return
        // }
        if (item.outlink) {
            var a = document.createElement("a");
            a.href = "".concat(item.outlink);
            a.target = "_blank";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            return;
        }
        router.push(item.path, item.path, {
            shallow: true
        });
    }, [
        active,
        nav
    ]);
    var searchNode = function(data, path) {
        for(var i = 0; i < (data === null || data === void 0 ? void 0 : data.length); i++){
            var item = data[i];
            if (item.path === path) {
                return item;
            }
            if (item.children && Array.isArray(item.children)) {
                var found = searchNode(item.children, path);
                if (found) {
                    return found;
                }
            }
        }
        return null;
    };
    // useEffect(() => {
    //   const { text } = router.query;
    //   setIsSearch(!!text)
    // }, [router.query])
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var act = searchNode(nav, newsPath || router.asPath);
        setActive(act);
        var item = nav === null || nav === void 0 ? void 0 : nav.find(function(item) {
            return item.id === (act === null || act === void 0 ? void 0 : act.parent);
        });
        setMenu(item);
    }, [
        nav
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            backgroundColor: backgroundColor
        },
        className: "jsx-ce7ef83832b5ae40" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().page) || ""),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "jsx-ce7ef83832b5ae40" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().pageBg) || ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: (active === null || active === void 0 ? void 0 : active.banner) || banner,
                        alt: "",
                        className: "jsx-ce7ef83832b5ae40"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "jsx-ce7ef83832b5ae40" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().pageHeader) || ""),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "jsx-ce7ef83832b5ae40",
                                children: "有机，可持续生活之美"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: "jsx-ce7ef83832b5ae40",
                                children: (menu === null || menu === void 0 ? void 0 : menu.name) || (active === null || active === void 0 ? void 0 : active.name)
                            }),
                            !isSearch && (menu === null || menu === void 0 ? void 0 : menu.children) && menu.children.length > 1 && (menu.children.length == 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: "jsx-ce7ef83832b5ae40",
                                children: menu === null || menu === void 0 ? void 0 : menu.children[0].name
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                className: "jsx-ce7ef83832b5ae40" + " " + (classnames__WEBPACK_IMPORTED_MODULE_5___default()([
                                    (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().pageNav)
                                ]) || ""),
                                children: menu === null || menu === void 0 ? void 0 : (ref = menu.children) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        style: {
                                            zIndex: "100",
                                            background: item.id === (active === null || active === void 0 ? void 0 : active.id) ? "#93d40b" : ""
                                        },
                                        onClick: function(e) {
                                            return navTo(e, item);
                                        },
                                        className: "jsx-ce7ef83832b5ae40",
                                        children: item.name
                                    }, item.id);
                                })
                            })),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .Swiper */ .tq, {
                                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().swiper),
                                modules: [],
                                spaceBetween: 15,
                                slidesPerView: "auto",
                                style: {
                                    display: "none"
                                },
                                children: [
                                    !isSearch && (menu === null || menu === void 0 ? void 0 : menu.children) && menu.children.length > 1 && (menu.children.length == 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                        className: "jsx-ce7ef83832b5ae40",
                                        children: menu === null || menu === void 0 ? void 0 : menu.children[0].name
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "jsx-ce7ef83832b5ae40",
                                        children: menu === null || menu === void 0 ? void 0 : (ref1 = menu.children) === null || ref1 === void 0 ? void 0 : ref1.map(function(item) {
                                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .SwiperSlide */ .o5, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    style: {
                                                        zIndex: "100",
                                                        background: item.id === (active === null || active === void 0 ? void 0 : active.id) ? "#93d40b" : ""
                                                    },
                                                    onClick: function(e) {
                                                        return navTo(e, item);
                                                    },
                                                    className: "jsx-ce7ef83832b5ae40" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().swiperList) || ""),
                                                    children: item.name
                                                })
                                            }, item.id);
                                        })
                                    })),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .SwiperSlide */ .o5, {})
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "jsx-ce7ef83832b5ae40" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().crumb) || ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "/image/crumb-icon.png",
                        alt: "",
                        className: "jsx-ce7ef83832b5ae40"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Breadcrumb */ .aG, {
                        compact: false,
                        routes: [
                            {
                                path: "/",
                                name: "首页"
                            },
                            {
                                path: (active === null || active === void 0 ? void 0 : active.path) || (menu === null || menu === void 0 ? void 0 : menu.path) || "",
                                name: (menu === null || menu === void 0 ? void 0 : menu.name) || "",
                                isShow: !menu
                            },
                            {
                                path: (active === null || active === void 0 ? void 0 : active.path) || "",
                                name: (active === null || active === void 0 ? void 0 : active.name) || "",
                                isShow: !active
                            }
                        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(crumb)).filter(function(item) {
                            return !item.isShow;
                        }),
                        onClick: function(item) {
                            router.push(item.path, item.path, {
                                shallow: true
                            });
                        },
                        separator: ">"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "jsx-ce7ef83832b5ae40" + " " + (classnames__WEBPACK_IMPORTED_MODULE_5___default()([
                    (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().content),
                    "content"
                ]) || ""),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "jsx-ce7ef83832b5ae40",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            width: "100%"
                        },
                        className: "jsx-ce7ef83832b5ae40",
                        children: children
                    })
                })
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "ce7ef83832b5ae40",
                children: '.semi-navigation{border:none!important;padding:0!important}.semi-navigation-header-text{width:100%}.semi-navigation-header{padding:0!important;margin-top:40px}.semi-navigation-item{height:auto!important;padding:0 12px!important}.semi-navigation-item-text{display:block;width:100%}.semi-navigation-footer{position:absolute;top:0;left:20%}.semi-navigation-list-wrapper{height:auto!important;padding:0!important;margin:10px 0}.semi-breadcrumb-item-active{color:#094020!important}.semi-navigation-collapsed{height:70px!important}.semi-breadcrumb-item-link:hover{color:#808080}.semi-notification-notice{min-width:"200px"}.swiper-wrapper,.swiper-slide{width:auto}.semi-breadcrumb-item-wrap{margin:4px 6px}'
            })
        ]
    });
};


/***/ }),

/***/ 51957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60357);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16528);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _components_pagelay__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41520);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74855);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30552);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48847);
/* harmony import */ var _utils_useDate__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19902);









// eslint-disable-next-line @typescript-eslint/no-var-requires
var showdown = __webpack_require__(53787);
var __N_SSP = true;
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(data) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    var converter = new showdown.Converter();
    var news = {
        1: "/media/show",
        2: "/media/industry",
        3: "/media/exhibitor"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pagelay__WEBPACK_IMPORTED_MODULE_3__/* .PageLayout */ .X, {
            crumb: [
                {
                    path: "/media/news_detail/".concat(data === null || data === void 0 ? void 0 : data.id),
                    name: data === null || data === void 0 ? void 0 : data.title_cn
                }, 
            ],
            newsPath: news[data === null || data === void 0 ? void 0 : data.category_id],
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "jsx-4bc8492bac12aabc" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().container) || ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "jsx-4bc8492bac12aabc" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().left) || ""),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "jsx-4bc8492bac12aabc",
                                children: data === null || data === void 0 ? void 0 : data.title_cn
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "jsx-4bc8492bac12aabc" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().share) || ""),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "jsx-4bc8492bac12aabc",
                                        children: (data === null || data === void 0 ? void 0 : data.publish_time) ? Object.values((0,_utils_useDate__WEBPACK_IMPORTED_MODULE_6__/* .useDate */ .Y)(data === null || data === void 0 ? void 0 : data.publish_time)).join("-") : ""
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "jsx-4bc8492bac12aabc",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_4__.CopyToClipboard, {
                                            text: "".concat(_utils__WEBPACK_IMPORTED_MODULE_8__/* .PRODFORNTDOMAIN */ .zE, "/media/news_detail/").concat(data === null || data === void 0 ? void 0 : data.id),
                                            onCopy: function() {
                                                _douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_5__/* .Notification.success */ .P_.success({
                                                    content: "复制成功！快去微信分享文章吧！",
                                                    duration: 3
                                                });
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "jsx-4bc8492bac12aabc" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().wx) || "")
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: converter.makeHtml(data === null || data === void 0 ? void 0 : data.content_cn)
                                },
                                className: "jsx-4bc8492bac12aabc" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().content) || "")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "jsx-4bc8492bac12aabc" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().footer) || ""),
                                children: [
                                    (data === null || data === void 0 ? void 0 : data.prev_article) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        href: (data === null || data === void 0 ? void 0 : (ref = data.prev_article) === null || ref === void 0 ? void 0 : ref.outlink) ? data === null || data === void 0 ? void 0 : (ref1 = data.prev_article) === null || ref1 === void 0 ? void 0 : ref1.outlink : "/media/news_detail/".concat(data === null || data === void 0 ? void 0 : (ref2 = data.prev_article) === null || ref2 === void 0 ? void 0 : ref2.id),
                                        className: "jsx-4bc8492bac12aabc",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                className: "jsx-4bc8492bac12aabc",
                                                children: [
                                                    "上一篇：",
                                                    data === null || data === void 0 ? void 0 : (ref3 = data.prev_article) === null || ref3 === void 0 ? void 0 : ref3.title_cn
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                className: "jsx-4bc8492bac12aabc",
                                                children: [
                                                    (0,_utils_useDate__WEBPACK_IMPORTED_MODULE_6__/* .useDate */ .Y)(data === null || data === void 0 ? void 0 : (ref4 = data.prev_article) === null || ref4 === void 0 ? void 0 : ref4.publish_time).year,
                                                    "年",
                                                    (0,_utils_useDate__WEBPACK_IMPORTED_MODULE_6__/* .useDate */ .Y)(data === null || data === void 0 ? void 0 : (ref5 = data.prev_article) === null || ref5 === void 0 ? void 0 : ref5.publish_time).month,
                                                    "月",
                                                    (0,_utils_useDate__WEBPACK_IMPORTED_MODULE_6__/* .useDate */ .Y)(data === null || data === void 0 ? void 0 : (ref6 = data.prev_article) === null || ref6 === void 0 ? void 0 : ref6.publish_time).day,
                                                    "日"
                                                ]
                                            })
                                        ]
                                    }),
                                    (data === null || data === void 0 ? void 0 : data.next_article) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        href: (data === null || data === void 0 ? void 0 : (ref7 = data.next_article) === null || ref7 === void 0 ? void 0 : ref7.outlink) ? data === null || data === void 0 ? void 0 : (ref8 = data.next_article) === null || ref8 === void 0 ? void 0 : ref8.outlink : "/media/news_detail/".concat(data === null || data === void 0 ? void 0 : (ref9 = data.next_article) === null || ref9 === void 0 ? void 0 : ref9.id),
                                        className: "jsx-4bc8492bac12aabc",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                className: "jsx-4bc8492bac12aabc",
                                                children: [
                                                    "下一篇：",
                                                    data === null || data === void 0 ? void 0 : (ref10 = data.next_article) === null || ref10 === void 0 ? void 0 : ref10.title_cn
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                className: "jsx-4bc8492bac12aabc",
                                                children: [
                                                    (0,_utils_useDate__WEBPACK_IMPORTED_MODULE_6__/* .useDate */ .Y)(data === null || data === void 0 ? void 0 : (ref11 = data.next_article) === null || ref11 === void 0 ? void 0 : ref11.publish_time).year,
                                                    "年",
                                                    (0,_utils_useDate__WEBPACK_IMPORTED_MODULE_6__/* .useDate */ .Y)(data === null || data === void 0 ? void 0 : (ref12 = data.next_article) === null || ref12 === void 0 ? void 0 : ref12.publish_time).month,
                                                    "月",
                                                    (0,_utils_useDate__WEBPACK_IMPORTED_MODULE_6__/* .useDate */ .Y)(data === null || data === void 0 ? void 0 : (ref13 = data.next_article) === null || ref13 === void 0 ? void 0 : ref13.publish_time).day,
                                                    "日"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                        id: "4bc8492bac12aabc",
                        children: ""
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 19902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useDate; },
/* harmony export */   "q": function() { return /* binding */ DateRangeFormatter; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var useDate = function(date) {
    var time = new Date(String(date).length === 10 ? date * 1000 : date);
    return {
        year: time.getFullYear(),
        month: time.getMonth() + 1 < 10 ? "0" + (time.getMonth() + 1) : time.getMonth() + 1,
        day: time.getDate() < 10 ? "0" + time.getDate() : time.getDate()
    };
};
var DateRangeFormatter = function(start, end) {
    // 日期解析器（规避时区问题）
    var parseDate = function(dateStr) {
        var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dateStr.split(" "), 1), datePart = ref[0];
        var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(datePart.split("-").map(Number), 3), year = ref1[0], month = ref1[1], day = ref1[2];
        return new Date(year, month - 1, day);
    };
    // 日期格式化
    var formatDateObj = function(date) {
        return {
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDate()
        };
    };
    // 主逻辑
    var generateRangeString = function() {
        var startDate = formatDateObj(parseDate(start));
        var endDate = formatDateObj(parseDate(end));
        if (start == end) {
            return "".concat(startDate.year, "年").concat(startDate.month, "月").concat(startDate.day, "日");
        }
        if (startDate.year === endDate.year) {
            if (startDate.month === endDate.month) {
                return "".concat(startDate.year, "年").concat(startDate.month, "月").concat(startDate.day, "-").concat(endDate.day, "日");
            }
            return "".concat(startDate.year, "年").concat(startDate.month, "月").concat(startDate.day, "日-").concat(endDate.month, "月").concat(endDate.day, "日");
        }
        return "".concat(startDate.year, "年").concat(startDate.month, "月").concat(startDate.day, "日-").concat(endDate.year, "年").concat(endDate.month, "月").concat(endDate.day, "日");
    };
    return generateRangeString();
};



/***/ }),

/***/ 55124:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"page":"styles_page__raIZH","pageBg":"styles_pageBg__uSGYm","pageHeader":"styles_pageHeader__Kkw7J","pageNav":"styles_pageNav__UKUc2","crumb":"styles_crumb__IAstN","content":"styles_content__eWsF4","swiper":"styles_swiper__r2mXM","swiperList":"styles_swiperList__Bj6Lh"};

/***/ }),

/***/ 16528:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Buga7","left":"styles_left__CaDxz","share":"styles_share__2RuZo","wx":"styles_wx__IEwNv","footer":"styles_footer__RvAEN"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [222,169,774,888,179], function() { return __webpack_exec__(71962); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);